import React from 'react';
import { ArrowRight } from 'lucide-react';
import { mockData, images } from '../utils/mock';

export const Hero = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(mockData.hero.whatsappMessage);
    window.open(`https://wa.me/${mockData.hero.whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={images.hero}
          alt="Familias 360"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 text-center">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight">
          {mockData.hero.title}
        </h1>

        <div className="space-y-2 mb-12">
          {mockData.hero.subtitle.map((line, index) => (
            <p
              key={index}
              className={`text-xl sm:text-2xl ${
                line === 'Pero la familia decide.'
                  ? 'text-orange-500 font-bold mt-6'
                  : 'text-white/90'
              }`}
            >
              {line}
            </p>
          ))}
        </div>

        <div className="h-px w-24 bg-gradient-to-r from-transparent via-orange-500 to-transparent mx-auto mb-12"></div>

        <p className="text-lg sm:text-xl text-white/80 mb-4 max-w-3xl mx-auto">
          {mockData.hero.description}
        </p>

        <p className="text-xl sm:text-2xl text-white font-semibold mb-12">
          {mockData.hero.highlight}
        </p>

        <button
          onClick={handleWhatsAppClick}
          className="group inline-flex items-center gap-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-2xl hover:shadow-orange-500/50 hover:scale-105"
        >
          {mockData.hero.cta}
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
        </button>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
            <div className="w-1.5 h-3 bg-orange-500 rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
